import React from 'react';
import { connect } from 'react-redux';

import Table from '../../table';

import { isSortedColumn } from '../../../../selectors';

const IndexTableBodyCell = props => <Table.BodyCell {...props} />;

const mapStateToProps = () => {
  const getSortedColumn = isSortedColumn();
  return (state, { name }) => ({
    dark: getSortedColumn(state, name),
  });
};

export default connect(mapStateToProps)(IndexTableBodyCell);
